import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const RecentAssets = () => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentAssets();
  }, []);

  const fetchRecentAssets = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem('authToken');

      if (!apiUrl || !token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${apiUrl}/assets?per_page=5`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.success) {
        setAssets(data.data);
      }
    } catch (err) {
      console.error('Failed to fetch recent assets:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const getConditionBadge = (condition) => {
    const badges = {
      excellent: 'bg-success-focus text-success-600',
      good: 'bg-info-focus text-info-600',
      fair: 'bg-warning-focus text-warning-600',
      poor: 'bg-danger-focus text-danger-600',
      damaged: 'bg-neutral-200 text-neutral-600'
    };
    return badges[condition] || badges.good;
  };

  return (
    <div className='col-12'>
      <div className='card h-100'>
        <div className='card-body p-24'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between mb-20'>
            <h6 className='mb-2 fw-bold text-lg mb-0'>Recent Assets</h6>
            <Link
              to='/asset-list'
              className='text-primary-600 hover-text-primary d-flex align-items-center gap-1'
            >
              View All
              <i className='ri-arrow-right-s-line' />
            </Link>
          </div>
          <div className='table-responsive scroll-sm'>
            <table className='table bordered-table sm-table mb-0'>
              <thead>
                <tr>
                  <th scope='col'>Item Name</th>
                  <th scope='col'>Tagging No.</th>
                  <th scope='col'>Category</th>
                  <th scope='col'>Location</th>
                  <th scope='col'>Condition</th>
                  <th scope='col'>Date Acquired</th>
                  <th scope='col' className='text-end'>Original Cost</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan='7' className='text-center py-4'>
                      <div className='spinner-border spinner-border-sm text-primary' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : assets.length === 0 ? (
                  <tr>
                    <td colSpan='7' className='text-center py-4 text-secondary-light'>
                      No assets found
                    </td>
                  </tr>
                ) : (
                  assets.map((asset) => (
                    <tr key={asset.id}>
                      <td>
                        <span className='text-md mb-0 fw-normal text-secondary-light'>
                          {asset.item_name}
                        </span>
                      </td>
                      <td>
                        <span className='badge bg-primary-50 text-primary-600 px-12 py-4 radius-4 fw-medium text-sm'>
                          {asset.tagging_number}
                        </span>
                      </td>
                      <td>
                        <span className='text-md mb-0 fw-normal text-secondary-light'>
                          {asset.asset_category}
                        </span>
                      </td>
                      <td>
                        <span className='text-md mb-0 fw-normal text-secondary-light'>
                          {asset.location || 'N/A'}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`${getConditionBadge(
                            asset.condition
                          )} px-20 py-4 radius-4 fw-medium text-sm text-capitalize`}
                        >
                          {asset.condition}
                        </span>
                      </td>
                      <td>
                        <span className='text-md mb-0 fw-normal text-secondary-light'>
                          {formatDate(asset.date_acquired)}
                        </span>
                      </td>
                      <td className='text-end'>
                        <span className='fw-semibold text-secondary-light'>
                          {formatCurrency(asset.original_cost)}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentAssets;

